(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('saasSwitch', ["path", "modals", function (path, modals) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('saas-switch').template(),
            scope: {
                activeSaas: '=saasSwitch',
                saasList: '=',
                confirmData: '@?',
                conditionData: '=?'
            },
            link: function ($scope) {
                $scope.onClick = function (event, saas) {
                    event.preventDefault();
                    event.stopPropagation();
                    if ($scope.confirmData && $scope.conditionData) {
                        return modals.confirm($scope.confirmData).then(function () {
                            $scope.activeSaas = saas.name;
                        });
                    }
                    $scope.activeSaas = saas.name;
                };
            }
        };
    }]);
}());